module.exports = __webpack_public_path__ + "assets/2c52b6dd61d2197dc966e9df952e48b9.mp4";